import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list Product-------
const getAllCompetibleBrand = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.competibleBrand.list + `${filter ? '?' + filter : ''}`);

    return data;
};
const GetAllCompetibleBrandQuery = (filter) => {
    return useQuery(['CompetibleBrand',filter], () => getAllCompetibleBrand(filter));

};
// ------------------ Add Product-------
const addCompetibleBrand = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.competibleBrand.add, payload);
};
const AddCompetibleBrandMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addCompetibleBrand, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('CompetibleBrand');
            toastMessage('success', 'Compatiable Brand Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Add Product-------
const deleteCompetibleBrand = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.competibleBrand.delete + id);
};
const DeleteCompetibleBrandMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteCompetibleBrand, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('CompetibleBrand');
            toastMessage('success', 'Compatible Brand Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Update Competible Brand-------
const updateCompetibleBrand = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.competibleBrand.update + id, payload);
};
const UpdateCompetibleBrandMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateCompetibleBrand, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('CompetibleBrand');
            toastMessage('success', 'Compatible Brand Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllCompetibleBrandQuery, AddCompetibleBrandMutation, DeleteCompetibleBrandMutation, UpdateCompetibleBrandMutation };
